import {
  type GeofenceTrigger_CalculateForJob_Read,
  type GeofenceTrigger_NextBillionGeofence_Read,
  type GeofenceTriggerType,
  type JobEvent_Simulation_Trigger,
} from '@treadinc/horizon-api-spec';
import dayjs, { type Dayjs } from 'dayjs';

export class CalculatedGeofenceTrigger {
  constructor(
    private _geofence_trigger_type: GeofenceTriggerType,
    private _triggered_location: {
      id: string;
      lat: string;
      lon: string;
      occurred_at: Dayjs;
      raw_occurred_at: string;
    },
    private _geofence: {
      id: string | null;
      site_id: string | null;
      tag: string;
      geofence: GeofenceTrigger_NextBillionGeofence_Read['geofence'];
    },
  ) {}

  public get geofenceTriggerType() {
    return this._geofence_trigger_type;
  }

  public get triggeredLocation() {
    return this._triggered_location;
  }

  public get geofence() {
    return this._geofence;
  }

  public toSimulationTrigger(): JobEvent_Simulation_Trigger {
    return {
      geofence_trigger_type: this._geofence_trigger_type,
      triggered_location: {
        id: this._triggered_location.id,
        lat: this._triggered_location.lat,
        lon: this._triggered_location.lon,
        occurred_at: this._triggered_location.raw_occurred_at,
      },
      geofence: {
        id: this._geofence.id ?? '',
        site_id: this._geofence.site_id ?? '',
        tag: this._geofence.tag,
        geofence: this._geofence.geofence as { [key: string]: unknown } | undefined,
      },
    };
  }

  public static parse(
    proto: GeofenceTrigger_CalculateForJob_Read,
  ): CalculatedGeofenceTrigger {
    return new CalculatedGeofenceTrigger(
      proto.geofence_trigger_type,
      {
        id: proto.triggered_location.id,
        lat: proto.triggered_location.lat,
        lon: proto.triggered_location.lon,
        occurred_at: dayjs(proto.triggered_location.occurred_at),
        raw_occurred_at: proto.triggered_location.occurred_at,
      },
      {
        id: proto.geofence.id ?? null,
        site_id: proto.geofence.site_id ?? null,
        tag: proto.geofence.tag,
        geofence: proto.geofence.geofence,
      },
    );
  }
}
